<template>

  <div>
    <transition name="modal">
      <div v-if="isShow">
        <div class="overlay" @click.self="hide()">
          <div class="modal">
            <h3>Lỗi phiên bản</h3>
            <p>Vui lòng cập nhật phiên bản mới nhất</p>
            <button @click="hide()">Đồng ý</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: 'app-dialog',
  computed: {
    isShow () {
      return this.$store.state.common["showPopup"]
    }
  },
  methods: {
    hide() {
      // method for closing modal
      store.dispatch("common/setStateShowModal", false);
    },
  }
}

</script>

<style scoped>

.modal {
  width: 330px;
  margin: 0px auto;
  padding: 30px 20px 20px;
  text-align: center;
  background-color: #fff;
  border-radius: 4px;
  transition: all 0.2s ease-in;
  font-family: Helvetica, Arial, sans-serif;
}

.fadeIn-enter {
  opacity: 0;
}

.fadeIn-leave-active {
  opacity: 0;
  transition: all 0.2s step-end;
}

.fadeIn-enter .modal,
.fadeIn-leave-active.modal {
  transform: scale(1.1);
}

h3 {
  font-weight: 600;
  font-size: 20px;
}

p {
  padding-top: 5px;
  font-size: 16px;
}

button {
  padding: 7px;
  margin-top: 10px;
  background-color: #0779ff;
  color: white;
  width: 100%;
  border-radius: 4px;
  font-size: 1.1rem;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #00000094;
  z-index: 999;
  transition: opacity 0.2s ease;
}

</style>
